import React from 'react'

import { Stack, Text, Box } from '@mindfulchefuk/design-system'
import { FormControl, FormInput, FormLabel } from '@mindfulchefuk/forms'

export const AnonymousUserInputDetails = () => (
  <Box>
    <Text as="h3" variant="heading-lg" mb={16}>
      Please enter your details
    </Text>
    <Stack spacing={20}>
      <FormControl type="text" name="firstName" id="firstName">
        <FormLabel>Your First name</FormLabel>
        <FormInput />
      </FormControl>
      <FormControl type="text" name="lastName" id="lastName">
        <FormLabel>Your Last name</FormLabel>
        <FormInput />
      </FormControl>
      <FormControl type="email" name="email" id="email">
        <FormLabel>Your Email address</FormLabel>
        <FormInput />
      </FormControl>
      <FormControl type="email" name="confirmEmail" id="confirmEmail">
        <FormLabel>Confirm Your Email address</FormLabel>
        <FormInput />
      </FormControl>
    </Stack>
    <Text as="h3" variant="heading-md" mt={6}>
      Your purchase
    </Text>
  </Box>
)
